/**
 * formats a string by replacing all %s with arguments
 * Example:
 *
 *  formatString("Hello %s", "World")
 *   => Hello World
 */
export function formatString() {
  let a;
  let b;
  let c;
  // biome-ignore lint/complexity/noArguments: legacy variadic helper forwards the original arguments object
  a = arguments[0];
  b = [];
  // biome-ignore lint/complexity/noArguments: legacy variadic helper forwards the original arguments object
  for (c = 1; c < arguments.length; c++) {
    // biome-ignore lint/complexity/noArguments: legacy variadic helper forwards the original arguments object
    b.push(arguments[c]);
  }
  for (c in b) {
    a = a.replace(/%[a-z]/, b[c]);
  }
  return a;
}
